import RewardBadge from '@/components/Icon/CustomIcons/RewardBadge.svg'
import Text from '../Text'
import {
  ProgramRewardsByCategory,
  ProgramRewardsDeviceAmount,
} from '@/types/programs-new/programs-new'
import { DeviceType } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'
import { getMinMaxRangeString } from './program-rewards-utils'
import { match } from 'ts-pattern'

function deviceTypeDisplayName(deviceType: DeviceType): string {
  return match(deviceType)
    .with('vehicle', () => 'vehicle')
    .with('thermostat', () => 'thermostat')
    .with('vehicleCharger', () => 'charger')
    .with('energySystem', () => 'battery')
    .otherwise(() => 'device')
}

function deviceTerm(rewards: ProgramRewardsDeviceAmount[]): string {
  const uniqueTypes = [...new Set(rewards.map((r) => r.deviceType))]
  return uniqueTypes.length === 1
    ? deviceTypeDisplayName(uniqueTypes[0])
    : 'device'
}

export default function ProgramRewardsList({
  rewardsByCategory: {
    enrollment,
    application,
    referral,
    participation,
    offPeakCharging,
    endOfProgram,
  },
  offPeakChargingLabel,
}: {
  rewardsByCategory: ProgramRewardsByCategory
  offPeakChargingLabel?: string
}) {
  return (
    <section>
      <div className="flex flex-col gap-2">
        {enrollment && (
          <RewardListItem
            title={`Enrollment`}
            content={`$${getMinMaxRangeString(enrollment)} per ${deviceTerm(
              enrollment,
            )}`}
          />
        )}
        {application && (
          <RewardListItem
            title={`Application`}
            content={`$${getMinMaxRangeString(application)} per ${deviceTerm(
              application,
            )}`}
          />
        )}
        {participation && (
          <RewardListItem
            title={`Participation`}
            content={`$${getMinMaxRangeString(participation)} per ${deviceTerm(
              participation,
            )}/year`}
          />
        )}
        {referral && (
          <RewardListItem
            title={`Referral`}
            content={`$${getMinMaxRangeString(referral)} per referral`}
          />
        )}
        {offPeakCharging && (
          <RewardListItem
            title={offPeakChargingLabel || 'Clean Power Hours'}
            content={`$${getMinMaxRangeString(offPeakCharging)} per kWh used`}
          />
        )}
        {endOfProgram && (
          <RewardListItem
            title={`End of Program`}
            content={`$${getMinMaxRangeString(endOfProgram)} per ${deviceTerm(
              endOfProgram,
            )}`}
          />
        )}
      </div>
    </section>
  )
}

export function RewardListItem({
  content,
  title,
}: {
  content: string
  title: string
}) {
  return (
    <div className="flex flex-row gap-2 items-center">
      <img
        src={RewardBadge}
        className="size-6 rounded-full fill-base-success bg-base-green-100"
      />
      <Text
        variant="body2"
        className="!text-xs !text-[#343434] !font-weight-[600]"
      >
        {title}:{' '}
      </Text>
      <Text variant="body2" className="!font-bold text-base-green-700 !text-xs">
        {content}
      </Text>
    </div>
  )
}
